// eslint-disable-next-line import/no-anonymous-default-export
export default function (count, noun, suffix = 's') {
    return `${count} ${noun}${count > 1 ? suffix : ''}`
}
